import React from 'react'
import PropTypes from 'prop-types'

const CardButton = ({ card, children, cardProps = {}, isEditing = true }, { editor }) =>
  <button onClick={() => editor.insertCard(card, cardProps, isEditing)} type='button'>
    {children}
  </button>

CardButton.contextTypes = {
  editor: PropTypes.object
}

export default CardButton



// WEBPACK FOOTER //
// ./app/components/editor/CardButton.js